import { LaunchAffiliateAccountDashboardResponse } from "@syla/shared/types/responses/LaunchAffiliateAccountDashboardResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function manageAffiliateAccount(): Promise<LaunchAffiliateAccountDashboardResponse> {
  try {
    const response = await axios.post<LaunchAffiliateAccountDashboardResponse>(
      "/users/launch-affiliate-account-dashboard",
    );
    return response.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
